import { onCtxAbort, reaction, reatomAsync } from '@reatom/framework'

import { Duration, pipe, Result } from '@blade/std-lib'
import { isLoggedInAtom } from '@root/entities/auth'
import { unauthorizedEvent } from '@root/features/realtime/reatom-websocket-main'
import { dependenciesAtom } from '@root/features/shared/dependencies'

import { createSupportWsTokenRequestAction } from './support-requests'

const acquireWsToken = reatomAsync(async (ctx) => {
  const wsTokenResult = await ctx.schedule(() =>
    createSupportWsTokenRequestAction(ctx),
  )

  if (Result.isSuccess(wsTokenResult)) {
    const { mainWebsocket } = ctx.get(dependenciesAtom)
    const ms = pipe(
      Duration.seconds(wsTokenResult.success.expiresInSec),
      Duration.subtract(Duration.minutes(1)),
      Duration.toMillis,
    )
    mainWebsocket.sendWsTicket(ctx, wsTokenResult.success.token)
    const timeoutId = setTimeout(() => {
      acquireWsToken(ctx)
    }, ms)
    onCtxAbort(ctx, () => clearTimeout(timeoutId))
    return
  }

  // eslint-disable-next-line no-console
  console.error('Failed to acquire WS token')
}, 'acquireWsToken')

export const initializeSupportWsTokenAction = reaction((ctx) => {
  const isLoggedIn = ctx.spy(isLoggedInAtom)
  if (!isLoggedIn) {
    return
  }

  acquireWsToken(ctx)

  unauthorizedEvent.onCall((ctx) => {
    acquireWsToken(ctx)
  })
}, 'initializeSupportWsTokenAction')
